import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight, IconInfo, IconScannerERx } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../../global-config'
import { urlResolverGetRedeemEprescription } from '../../../../../url-handling'

export const RxLpComHowBonusIsCalculatedInfo: FC = () => {
  const config = useGlobalConfigContext()

  return (
    // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
    <div className="flex shrink-0 grow-0 basis-[35%] flex-col gap-4 rounded-m bg-light-primary-low p-6">
      <p className="text-s">
        <FormattedMessage id="rx.com.bonus.description" />
      </p>

      <div className="flex flex-row gap-1">
        <IconInfo className="size-6 shrink-0" />
        <span className="font-medium">
          <FormattedMessage id="rx.com.bonus.info" />
        </span>
      </div>

      <Button<'a'>
        className="flex w-fit flex-row items-center justify-start gap-1"
        endIcon={<IconArrowRight className="size-6 shrink-0 text-dark-brand" />}
        href={urlResolverGetRedeemEprescription(config)}
        size="medium"
        slots={{ root: 'a' }}
        startIcon={
          <IconScannerERx className="size-6 shrink-0 text-dark-brand" />
        }
        variant="text"
      >
        <FormattedMessage id="rx.com.bonus.cta" />
      </Button>
    </div>
  )
}
